import useModifiers from 'hooks/useModifiers';

export enum ActionModifier {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  STRETCH_LEFT = 'stretchLeft',
  NARROW = 'narrow',
  NO_MARGIN = 'noMargin',
}

export interface ActionProps {
  modifiers: ActionModifier[];
  children?: React.ReactElement[];
}

function Actions(props: ActionProps) {
  const mods = useModifiers(props.modifiers);

  return (
    <div className={`ct_actions ${mods}`}>
      {
        props.children && props.children.map((child, index) => (
          <div key={index}>{child}</div>
        ))
      }
    </div>
  );
}

Actions.defaultProps = { ...{} };

export default Actions;
